export default {
  data() {
    return {
      employees: {
        monthWorkHours: 160,
        employed: {},
        absence: {},
        available: {},
        availableHours: {
          all: {},
        },
      },
    };
  },
  methods: {
    /**
     * Fetch employees.
     * @param fetchDepartments
     * @returns {Promise<*>}
     */
    async fetchEmployees(fetchDepartments) {
      this.$startLoading('employees');

      const months = this.$getMonths();

      // fetch employees, month work hours and departments
      const [employees, monthWorkHours, departments] = await Promise.all([
        this.$api.employees.index(),
        this.$api.employees.monthWorkHours(),
        fetchDepartments,
      ]);

      // set month work hours
      this.employees.monthWorkHours = monthWorkHours;

      // set default values for employees
      departments.forEach(({ ID: departmentId }) => {
        this.employees.employed[departmentId] = {};
        this.employees.absence[departmentId] = {};
        this.employees.available[departmentId] = {};
        this.employees.availableHours[departmentId] = {};
        months.forEach(({ format: month }) => {
          this.employees.employed[departmentId][month] = '';
          this.employees.absence[departmentId][month] = 0;
          this.employees.available[departmentId][month] = '0';
          this.employees.availableHours[departmentId][month] = '0';
        });
      });

      // set default values for all available hours
      months.forEach(({ format: month }) => {
        this.employees.availableHours.all[month] = '0';
      });

      // set values for employees
      employees.forEach(({ Year, Month, Employed: employed, Absence: absence, DepartmentID: departmentId }) => {
        const month = this.$getFormat(Year, Month);
        this.employees.employed[departmentId][month] = employed;
        this.employees.absence[departmentId][month] = absence;
        this.calculateAvailableEmployeesAndHours(departmentId, month);
      });

      this.calculateAllAvailableHours();

      this.$stopLoading('employees');
      return employees;
    },
    /**
     * Update employees.
     * @param departmentId
     * @param type
     * @param month
     * @param oldValue
     * @param newValue
     * @returns {Promise<void>}
     */
    async updateEmployees(departmentId, type, month, oldValue, newValue) {
      // old available hours
      const oldAvailableHours = this.employees.availableHours[departmentId][month];

      // set employees to the new value
      this.employees[type][departmentId][month] = newValue;
      this.calculateAvailableEmployeesAndHours(departmentId, month);

      // new available hours
      const newAvailableHours = this.employees.availableHours[departmentId][month];

      this.calculateAllAvailableHours(month, oldAvailableHours, newAvailableHours);

      // prepare api data
      const apiType = `${type.charAt(0).toUpperCase()}${type.substring(1).toLowerCase()}`;
      const [apiYear, apiMonth] = month.split('-').map(number => parseInt(number, 10));

      try { // save new value
        this.$startLoading(`${type}-${month}`);
        await this.$api.employees.update(departmentId, apiYear, apiMonth, apiType, newValue);
        this.$stopLoading(`${type}-${month}`);
      } catch (err) {
        this.employees[type][departmentId][month] = oldValue;
        this.$stopLoading(`${type}-${month}`);
        throw err;
      }
    },
    /**
     * Calculate available employees and hours.
     * @param departmentId
     * @param month
     */
    calculateAvailableEmployeesAndHours(departmentId, month) {
      const employed = this.employees.employed[departmentId][month];
      if (employed !== '') {
        const absence = this.employees.absence[departmentId][month];
        const employedBig = this.$Big(employed.toString().replace(',', '.'), 2);
        const absenceBig = this.$Big(absence.toString().replace(',', '.'), 2);
        const availableEmployeesBig = employedBig.minus(absenceBig);
        const availableHoursBig = availableEmployeesBig.times(this.employees.monthWorkHours);
        this.employees.available[departmentId][month] = availableEmployeesBig.toString().replace('.', ',');
        this.employees.availableHours[departmentId][month] = availableHoursBig.toString().replace('.', ',');
        this.$forceUpdate();
      }
    },
    /**
     * Calculate all available hours.
     */
    calculateAllAvailableHours(month, oldAvailableHours, newAvailableHours) {
      if (month && oldAvailableHours && newAvailableHours) {
        const oldAvailableHoursBig = this.$Big(oldAvailableHours.toString().replace(',', '.'), 2);
        const newAvailableHoursBig = this.$Big(newAvailableHours.toString().replace(',', '.'), 2);
        // all available hours
        const allAvailableHours = this.employees.availableHours.all[month];
        let allAvailableHoursBig = this.$Big(allAvailableHours.toString().replace(',', '.'), 2);
        allAvailableHoursBig = allAvailableHoursBig.plus(newAvailableHoursBig.minus(oldAvailableHoursBig));
        // update all available hours
        this.employees.availableHours.all[month] = allAvailableHoursBig.toString().replace('.', ',');
      } else {
        const months = Object.keys(this.employees.availableHours.all);
        const departmentIds = Object.keys(this.employees.availableHours);
        departmentIds.splice(departmentIds.indexOf('all'), 1);
        months.forEach((month) => {
          const allAvailableHours = this.employees.availableHours.all[month];
          let allAvailableHoursBig = this.$Big(allAvailableHours.toString().replace(',', '.'), 2);
          departmentIds.forEach((departmentId) => {
            const availableHours = this.employees.availableHours[departmentId][month];
            const availableHoursBig = this.$Big(availableHours.toString().replace(',', '.'), 2);
            allAvailableHoursBig = allAvailableHoursBig.plus(availableHoursBig);
          });
          this.employees.availableHours.all[month] = allAvailableHoursBig.toString().replace('.', ',');
        });
      }
    },
  },
};
